/* Entry point for the RealU student-intake React island.
   Mounts SurveyApp into #survey-root on the survey-next preview page.
   Bundled by webpack (config-name "survey") to public/js/survey-react.js. */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import SurveyApp from './SurveyApp';
import {
  applyHabitConfig,
  applyGenderConfig,
  applyLifeIntroConfig,
  applyMaritalConfig,
  applyCategoriesConfig,
  applyGroupsConfig,
  applyEventInfo,
  applyEventError,
} from './data';

// Read server-injected config from the bare-layout #page-data island and
// hydrate the survey BEFORE mounting. The JSON is HTML-escaped by the Aleet
// template, so decode entities the same way public/js/app.js getPageData does.
function readPageData(): any {
  try {
    const node = document.getElementById('page-data');
    const raw = node && node.textContent ? node.textContent.trim() : '{}';
    const decoder = document.createElement('div');
    decoder.innerHTML = raw;
    return JSON.parse((decoder.textContent || '{}').trim());
  } catch (e) {
    return {};
  }
}

try {
  const pageData = readPageData();
  if (pageData && pageData.surveyConfig) {
    applyHabitConfig(pageData.surveyConfig.habits);
    applyGenderConfig(pageData.surveyConfig.genders);
    applyLifeIntroConfig(pageData.surveyConfig.lifeIntro);
    applyMaritalConfig(pageData.surveyConfig.marital);
    applyCategoriesConfig(pageData.surveyConfig.categories);
    applyGroupsConfig(pageData.surveyConfig.groups);
    applyEventInfo(pageData.surveyConfig.event);
    applyEventError(pageData.surveyConfig.eventError);
  }
} catch (e) {
  /* fall back to the hardcoded defaults in data.ts */
}

const el = document.getElementById('survey-root');
if (el) {
  createRoot(el).render(
    <React.StrictMode>
      <SurveyApp />
    </React.StrictMode>
  );
}
